export enum RequestAssigneeEnum {
    All = 0,
    AssignedToMe = 1,
    AssignedByMe = 2,
    FowardByMe = 3,
    OthersRequests = 4,
    MyRequests = 5,
}
